import { memo } from 'react';
import { css, cx } from '@eti/styles';
import { price as priceUtil } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const labelStyles = css`
  display: block;

  & strong {
    font-weight: 700;
    margin-left: 4px;
  }
`;
const genericStyles = css`
  max-width: 240px;
  z-index: 9999;
`;
const SeatToolTip = _ref => {
  let {
    id,
    isDesktop,
    price,
    seat
  } = _ref;
  const {
    t
  } = useTranslation();
  const tooltipSeatLabel = t('Product.SeatMap.Tooltip.Select');
  const tooltipPriceLabel = t('Product.SeatMap.Tooltip.Price');
  return /*#__PURE__*/_jsx(ReactTooltip, {
    className: cx('etiTooltip', genericStyles),
    clickable: !isDesktop,
    content: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("span", {
        className: labelStyles,
        children: [tooltipSeatLabel, /*#__PURE__*/_jsx("strong", {
          children: seat
        })]
      }), /*#__PURE__*/_jsxs("span", {
        className: labelStyles,
        children: [tooltipPriceLabel, /*#__PURE__*/_jsx("strong", {
          children: priceUtil.formatPrice(price)
        })]
      })]
    }),
    float: false,
    globalCloseEvents: "off",
    id: id,
    place: "top"
  });
};
export default /*#__PURE__*/memo(SeatToolTip);
//# sourceMappingURL=SeatTooltip.js.map